import React, { useState, useEffect } from "react";

import Header from "../pages/outros/templates/Header";
import Menu from "../pages/outros/templates/Menu";
import Footer from "../pages/outros/templates/Footer";
import LoadingInicial from "./LoadingInicial";

import { useAuthentication } from "../../src/hooks/useAuth";

const Layout = ({ children }) => {
  const { firstAccess, handleFirstAccess } = useAuthentication();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (firstAccess) {
      setLoading(true);
      setTimeout(() => {
        handleFirstAccess(false);
        window.location.reload();
        setLoading(false);
      }, 2300);
    }    
  }, [firstAccess, handleFirstAccess]);

  return loading ? (
    <LoadingInicial />
  ) : (
    <>
      <Header />
      <Menu />
      {children}
      <Footer />
    </>
  );
};

export default Layout;
